// eslint-disable-next-line no-unused-vars
import Pusher from 'pusher-js'
import Echo from 'laravel-echo'
import store from '../store'

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_KEY,
  cluster: process.env.VUE_APP_PUSHER_CLUSTER || 'eu',
  authEndpoint: process.env.VUE_APP_BROADCAST_URL,
  forceTLS: true,
  auth: {
    headers: {
      Authorization: `Bearer ${store.getters.token}`
    }
  }
})
